import {
  CButton,
  CAlert,
  CCallout,
  CCardHeader,
  CRow,
  CSpinner,
} from "@coreui/react";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Auth from "src/auth";

const PaymentReceipt = () => {
  const { authenticated } = Auth();
  let { id } = useParams();
  const [showList, setshowList] = useState();
  const [showError, setshowError] = useState();
  const [paymentInfoData, setPaymentInfoData] = useState();

  useEffect(() => {
    const getDetails = async () => {
      console.log("2");
      setshowError(false);
      if (id === "Error") {
        console.log("1");
        setshowError(true);
      } else {
        const header = new Headers();
        header.append("Content-Type", "application/json");
        header.append("Accept", "application/json");
        console.log("3");
        const responseData = await apiCall(
          `LotDetails/updateTransData?txnId=${id}`,
          "GET",
          header,
          null
        );
        const jsonobjData = await responseData.json();
        console.log("4");
        console.log(jsonobjData);
        if (responseData.status === 200) {
          console.log(jsonobjData);
          console.log("5");
          const tranResponseData = await apiCall(
            `LotDetails/getTranDetails?txnId=${id}`,
            "GET",
            header,
            null
          );
          const tranJsonobjData = await tranResponseData.json();
          console.log("6");
          console.log(tranJsonobjData);
          if (tranResponseData.status === 200) {
            console.log("7");
            setPaymentInfoData(tranJsonobjData);
            setshowList(true);
            console.log("8");
          } else {
            setshowList(false);
            console.log("9");
          }
        } else {
          setshowList(false);
          console.log("10");
        }
      }
    };
    getDetails();
  }, [id]);

  return (
    <>
      {showError ? (
        <CAlert color="danger">
          There is error processing your request, Please try again.
        </CAlert>
      ) : !showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        authenticated &&
        paymentInfoData && (
          <CCardHeader>
            <CCallout color="success">
              <h3>Payment Status</h3>
            </CCallout>
            <hr />
            <div className="pl-3 pr-3 mb-2">
              <CRow className="mt-3 ">
                <table className="responsive">
                  <tbody>
                    <tr>
                      <td className="p-2">
                        <b>Company Name : </b>
                      </td>
                      <td>{paymentInfoData.companyName}</td>
                    </tr>
                    <tr>
                      <td className="p-2">
                        <b>Tender No : </b>
                      </td>
                      <td>{paymentInfoData.tenderNumber}</td>
                    </tr>
                    <tr>
                      <td className="p-2">
                        <b>Lot Number : </b>
                      </td>
                      <td>{paymentInfoData.lotNo}</td>
                    </tr>
                    {paymentInfoData.challanId !== "" ? (
                      <tr>
                        <td className="p-2">
                          <b>Challan Refrence : </b>
                        </td>
                        <td>{paymentInfoData.challanId}</td>
                      </tr>
                    ) : (
                      ""
                    )}
                    <tr>
                      <td className="p-2">
                        <b>Payment Method : </b>
                      </td>
                      <td>{paymentInfoData.paymentType}</td>
                    </tr>
                    <tr>
                      <td className="p-2">
                        <b>Amount : </b>
                      </td>
                      <td>{paymentInfoData.amount}</td>
                    </tr>
                    <tr>
                      <td className="p-2">
                        <b>Payment Status : </b>
                      </td>
                      <td>{paymentInfoData.paymentStatus}</td>
                    </tr>
                    <tr>
                      <td className="p-2">
                        <b>Transaction Reference : </b>
                      </td>
                      <td>{paymentInfoData.txnId}</td>
                    </tr>
                    <tr>
                      <td className="p-2">
                        <b>Transaction Date : </b>
                      </td>
                      <td>{paymentInfoData.transactionDateTime}</td>
                    </tr>

                    {paymentInfoData.isEMDPaymentByCheque === true && (
                      <>
                        <tr>
                          <td className="p-2">
                            <b>Bank Name : </b>
                          </td>
                          <td>{paymentInfoData.bankName}</td>
                        </tr>
                        <tr>
                          <td className="p-2">
                            <b>Cheque Number : </b>
                          </td>
                          <td>{paymentInfoData.chequeNo}</td>
                        </tr>
                      </>
                    )}
                    <tr>
                      <td colSpan="2">
                        {paymentInfoData.isReceiptPDFGenerated === true ? (
                          <>
                            <a
                              href={`${downloadUrl}/${paymentInfoData.receiptGeneratedPath}`}
                              target="_blank"
                              className="ml-2"
                              rel="noreferrer"
                            >
                              <CButton
                                variant="outline"
                                shape="square"
                                size="sm"
                                color="success"
                              >
                                View Receipt
                              </CButton>
                            </a>
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
              <CRow className="mt-5">
                <CButton
                  color="dark"
                  to={`/lotlistview/${window.btoa(paymentInfoData.lotId)}`}
                >
                  Go Back
                </CButton>
              </CRow>
            </div>
          </CCardHeader>
        )
      )}
    </>
  );
};
export default PaymentReceipt;
